"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var clone = require('clone');

var PersonReference = require('../core/person-reference');

var FlexibleQuestionnaire = require('../flexible-questionnaire/flexible-questionnaire');

var Access = require('../common/access');

var UseAuthorization = /*#__PURE__*/function (_FlexibleQuestionnair) {
  _inherits(UseAuthorization, _FlexibleQuestionnair);

  var _super = _createSuper(UseAuthorization);

  function UseAuthorization(opt) {
    var _this;

    _classCallCheck(this, UseAuthorization);

    _this = _super.call(this, opt);
    _this.comments = null;
    _this.status = null;
    _this.templateId = null;
    _this.templateType = null;
    _this.templatePrefix = null;
    _this.ruleSet = null;
    _this.rp = null;
    _this.number = null;
    _this.error = null;
    _this.assignedTo = null;
    _this.expirationDate = null;
    _this.approvalDate = null;
    _this.access = null;
    _this.isAmendment = false;

    if (opt) {
      _this.fillObject(clone(opt));
    }

    return _this;
  }

  _createClass(UseAuthorization, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.comments = opt.comments;
      this.status = opt.status;
      this.templateId = opt.templateId;
      this.templateType = opt.templateType;
      this.templatePrefix = opt.templatePrefix;
      this.ruleSet = opt.ruleSet;
      this.rp = new PersonReference(opt.rp);
      this.number = opt.number;
      this.error = opt.error;
      this.assignedTo = opt.assignedTo;
      this.approvalDate = opt.approvalDate ? new Date(opt.approvalDate) : null;
      this.expirationDate = opt.expirationDate ? new Date(opt.expirationDate) : null;
      this.access = opt.access && opt.access.length ? opt.access.map(function (item) {
        return new Access(item);
      }) : [];
      this.isAmendment = opt.isAmendment || false;
    }
  }]);

  return UseAuthorization;
}(FlexibleQuestionnaire);

module.exports = UseAuthorization;